var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"complex-card"},[_c('img',{attrs:{"src":_vm.content.img,"alt":_vm.content.img}}),_c('div',{staticClass:"text"},[_c('vue-markdown',[_vm._v(_vm._s(_vm.content.text))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }